const locale = {
  id: 'ClassConstant',
  code: 'CN',
  text: {
    "./images/class_en@2x.png": "./images/Class@2x.png",
    'Class Management is Suitable for all Teaching Scenarios': '适用于所有教学场景的班级体系',
		'Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.': '创建班级，排课，补课，试听，签到，设置任课教师，教室。大到几千人，小到几个人。可按期，按次，按时等跟踪课程进度。智能冲突系统可有效的提醒学校资源的重叠使用。自由的排课系统满足任何您需要的班级体系。',

  }
}

export const onBoardingContents = {
  // we show this when student state is 'current'
  current: {
    title: __('Class Management is Suitable for all Teaching Scenarios', locale),
    text: __('Class Management allows you to create classes, schedule lessons, auditions. attendance, appoint teachers and classrooms. Each class can be designed to be billed by lesson, date, or hour to keep track of the class status. It will also remind you when there is conflict between different classes.', locale),
    image: require(__('./images/class_en@2x.png', locale)),
    showArrow: true,
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Class/constant.js